import Cookies from 'js-cookie'
const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name ,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  logo: state => state.app.logo,
  rolenames: state => Cookies.get('roleNames') || state.user.rolenames,
  nickName: state => Cookies.get('nickName') || state.user.nickName,
  addDate: state => Cookies.get('addDate') || state.user.addDate,
  deptName: state => Cookies.get('deptName') || state.user.deptName,
  userInfo: state => JSON.parse(localStorage.getItem("userInfo")) || state.user.userInfo  || {},
  currentExhibitionName: state => state.user.currentExhibitionName,
  

}
export default getters
